import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M40 80q0-52 60-52t60 52v90q-15-12-30 0-15-12-30 0-15-12-30 0-15-12-30 0Z" }, null, -1),
    _createElementVNode("ellipse", {
      cx: "78",
      cy: "86",
      fill: "var(--mc-avatar)",
      rx: "10",
      ry: "14"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "122",
      cy: "86",
      fill: "var(--mc-avatar)",
      rx: "10",
      ry: "14"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "100",
      cy: "120",
      fill: "var(--mc-avatar)",
      rx: "14",
      ry: "10"
    }, null, -1)
  ]))]))
}
export default { render: render }